class Intervals {

  currentIntervals = [];
  songbookInterval = null;
  newTracksInterval = null;
  statusReportInterval = null;
  externalScreenInterval = null;
  castCheckInterval = null;
  songbookPlayqueueInterval = null;
  castingTimeout = null;
  subInterval = null;
  externalScreenCurrentTimeInterval = null;
  musicFadeInInterval = null;
  musicFadeOutInterval = null;
  streamUrlTimeouts = [];

  addStreamUrlTimeout(timeout){
    this.streamUrlTimeouts.push(timeout)
  }

  clearAllStreamUrlTimeouts(){
    this.streamUrlTimeouts.forEach(timeout => {
      clearTimeout(timeout);
    });
    this.streamUrlTimeout = [];
  }

  isFadingIn(){
    return this.musicFadeInInterval;
  }

  isFadingOut(){
    return this.musicFadeOutInterval;
  }

  addMusicFadeInInterval(interval) {
    console.log("set fadeIn")
    this.musicFadeInInterval = interval;
  }

  addMusicFadeOutInterval(interval) {
    this.musicFadeOutInterval = interval;
  }

  clearMusicFadeInInterval() {
    clearInterval(this.musicFadeInInterval);
    this.musicFadeInInterval = null;
  }

  clearMusicFadeOutInterval() {
    clearInterval(this.musicFadeOutInterval);
    this.musicFadeOutInterval = null;
  }

  addInterval(interval, clearFunc) {
    this.currentIntervals.push({
      interval: interval,
      clearFunc: clearFunc
    });
  }

  clearAllIntervals() {
    this.currentIntervals.forEach(element => {
      clearInterval(element.interval);
      element.clearFunc();
    });
    this.currentIntervals = [];
  }

  setCastingTimeout(timeout) {
    this.castingTimeout = timeout;
  }

  clearCastingTimeout() {
    clearTimeout(this.castingTimeout);
  }

  setSubInterval(interval){
    this.subInterval=interval;
  }

  clearSubInterval(){
    clearInterval(this.subInterval);
  }

  setSongbookInterval(interval) {
    this.songbookInterval = interval;
  }

  setNewTracksInterval(interval) {
    this.newTracksInterval = interval;
  }

  clearSongbookInterval() {
    clearInterval(this.songbookInterval);
  }

  clearNewTracksInterval() {
    clearInterval(this.newTracksInterval);
  }

  setStatusReportInterval(interval) {
    this.statusReportInterval = interval;
  }

  clearStatusReportInterval() {
    clearInterval(this.statusReportInterval);
  }

  setExternalScreenInterval(interval) {
    this.externalScreenInterval = interval;
  }

  setCastCheckInterval(interval) {
    this.castCheckInterval = interval;
  }

  setSongbookPlayqueueInterval(interval) {
    this.songbookPlayqueueInterval=interval;    
  }

  clearSongbookPlayqueueInterval(){
    clearInterval(this.songbookPlayqueueInterval);
  }

  setExternalScreenCurrentTimeInterval(interval) {
    this.externalScreenCurrentTimeInterval=interval;    
  }

  clearExternalScreenCurrentTimeInterval(){
    clearInterval(this.externalScreenCurrentTimeInterval);
  }

}

export default new Intervals();